<template>
  <div class="p-3 flex flex-col bg-key rounded-4xl">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-1 h-9 text-black-white text-l-medium">
        <Icon icon="Hardware-Wireframe-10Battery" class="size-6" />
        <span class="text-l-medium text-black-white">{{
          t('setting.device.lowBattery.title')
        }}</span>
      </div>
      <div>
        <Switch
          size="lg"
          :model-value="state.lowBatteryLight.value"
          @update:model-value="actions.setLowBatteryLight"
        />
      </div>
    </div>
    <div>
      <p class="text-m-medium text-text-glass-default">
        {{ t('setting.device.lowBattery.description') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Icon, Switch } from '@rapoo/element'
  import { useLocaleStore } from '@/stores'
  import type { ParametersContext } from '../../composables/useParameters'

  const { t } = useLocaleStore()
  const props = defineProps<{
    parameters: ParametersContext
  }>()
  const { state, actions } = props.parameters
</script>
